import React from "react";
import PropTypes from "prop-types";
import styles from "./Education.css";
import EducationItem from "./EducationItem/EducationItem";

const Education = ({ education }) => {
  const educationItems = education.map(item => <EducationItem item={item} />);

  return (
    <div className={styles.Education}>
      <div className={styles.EducationHeader}>
        <h2>Education History</h2>
        {educationItems}
      </div>
    </div>
  );
};

Education.propTypes = {
  education: PropTypes.instanceOf(Array).isRequired
};

export default Education;



// WEBPACK FOOTER //
// ./src/containers/ResumeBox/Resume/Education/Education.js